module.exports = __webpack_public_path__ + "img/defaultCoinIco.9095d9f0.png";